import type { CSSProperties } from "react";

/** 課業日程表「選擇日期」图标(2026-07-28 换稿替换 lucide CalendarRange)：stroke 走 currentColor，用法同 lucide(className size-* 或 size 传像素) */
export function CalendarPickerIcon({
  size,
  className,
  style,
  // 原稿 stroke-width=3 按大尺寸画，24px 下占格距 45% 糊成实心网格块；几何不动只把线宽收到 2
  strokeWidth = 2,
}: {
  size?: number;
  className?: string;
  style?: CSSProperties;
  strokeWidth?: number;
}) {
  return (
    <svg
      viewBox="0 0 25 25"
      width={size}
      height={size}
      className={className}
      style={style}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.4 3.70001H2.6C1.99249 3.70001 1.5 4.1925 1.5 4.80001V22.4C1.5 23.0075 1.99249 23.5 2.6 23.5H22.4C23.0075 23.5 23.5 23.0075 23.5 22.4V4.80001C23.5 4.1925 23.0075 3.70001 22.4 3.70001Z" />
      <path d="M1.5 10.3H23.5" />
      <path d="M1.5 16.9H23.5" />
      <path d="M8.6499 1.5V5.9" />
      <path d="M16.3501 1.5V5.9" />
      <path d="M8.6499 10.3V23.5" />
      <path d="M16.3501 10.3V23.5" />
      <path d="M23.5 6.45001V20.75" />
      <path d="M1.5 6.45001V20.75" />
      <path d="M7 23.5H18" />
    </svg>
  );
}
